import {debounceTime} from 'rxjs/operators';
import {Component, OnInit, Input, OnDestroy, OnChanges, SimpleChanges} from '@angular/core';
import {WizardWidgetComponent} from '../wizard-widget/wizard-widget.component';
import {ProductService} from '../../../services';
import {DataHandlerService} from '../../../services/data-handler.service';

@Component({
    selector: 'app-product',
    templateUrl: './product.component.html',
    standalone: true
})
export class ProductComponent extends WizardWidgetComponent implements OnInit, OnChanges, OnDestroy {
  public subscriptions = [];

  @Input() type: String = 'home-loan'; // set as motor-vehicle by default
  @Input() public faType: string;
  @Input() applicationType: any;
  @Input() isFurtherAdvance = false;

  constructor(public dataHandlerService: DataHandlerService,
              private productService: ProductService) {
    super(dataHandlerService);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  ngOnInit() {
    super.ngOnInit();

    if (this.opts.type) {
      this.formGroup.patchValue({type: this.opts.type});
    }

    const currentParams: any = this.formGroup.value;
    currentParams.applicationType = (this.isFurtherAdvance) ? 'further-advance' : this.applicationType;

    // initialize by retrieving at the start
    const hasOutput = this.formGroup.value.output && this.formGroup.value.output.length > 0;
    if (hasOutput) {
      this.productService.setProductData(this.formGroup.value.output);
    } else if (currentParams.oid && currentParams.type) {
      const svc = (this.opts.type === 'home-loan') ? this.productService.getHomeLoanVariationsList(currentParams) : null;
      svc.subscribe((res) => {
        this.productService.setProductData({input: currentParams, output: res});
      });
    }

    this.subscriptions.push(this.formGroup.valueChanges.pipe(debounceTime(500)).subscribe((val: any) => {
      this.getHomeLoanVariations(val);
    }));

    // if any of the product parameters change
    this.subscriptions.push(this.productService.productParameters.subscribe((val) => {
      const fgVal = Object.assign({}, this.formGroup.value);
      let newVal = fgVal;
      if (val) {
        newVal = Object.assign({}, fgVal, val);
        // strip out output
        if (JSON.stringify(newVal) === JSON.stringify(fgVal)) { // if nothing changed do nothing
          return;
        }
        this.formGroup.patchValue(newVal);
      }
    }));
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.applicationType && changes.applicationType.currentValue !== changes.applicationType.previousValue && !changes.applicationType.firstChange) {
      this.applicationType = changes.applicationType.currentValue;
      this.getHomeLoanVariations();
    }
  }

  getHomeLoanVariations(val?) {
    const data: any = (val) ? val : this.formGroup.value;

    if (this.isFurtherAdvance && this.faType === 'existing-security') {
      data.applicationType = 'further-advance';
    }
    if (data.oid && data.type) {
      if (this.applicationType === 'new-bridging') {
        data.bridging = true;
      } else {
        delete data.bridging;
      }

      const svc = (this.opts.type === 'home-loan') ? this.productService.getHomeLoanVariationsList(data) : null;
      svc.subscribe((res) => {
        this.productService.setProductData({input: data, output: res});
      });
    }
  }
}
